import React, { useEffect, useState } from "react";
import "./preloader.css";
import "../styles/global.css";

export default function Preloader({ minTime = 600 }) {
  // minTime ensures loader shows for at least this many ms (optional nice touch)
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    let mounted = true;
    const hide = () => {
      if (!mounted) return;
      // small delay so loader is not flashy on very fast loads
      setTimeout(() => setVisible(false), 150);
    };

    // If browser fires load event after all resources are loaded
    if (document.readyState === "complete") {
      // already loaded
      hide();
    } else {
      // wait for window load
      const onLoad = () => hide();
      window.addEventListener("load", onLoad);
      return () => {
        mounted = false;
        window.removeEventListener("load", onLoad);
      };
    }
  }, []);

  if (!visible) return null;

  return (
    <div className="preloader-overlay" role="status" aria-label="Loading">
      <div className="preloader-box">
        <div className="spinner" />
        <div className="preloader-text">Loading…</div>
      </div>
    </div>
  );
}
